import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import MindalaySvg from "../../../Components/Svg/midalaySvg";
import TranslationService from "../../../Services/translationService";
import { showOrHideGeneralDashboardLeftMenu } from "../../../Store/Actions/generalLeftMenu";
import { ADMIN_USER_TYPE, ERROR_KEY } from "../../../Constants/mainKeys";
import Collapse from "react-bootstrap/Collapse";

const DeveloperLeftMenu = props => {
	const dispatch = useDispatch();
	const language = useSelector(state => state.language.language);
	const { user } = useSelector(state => state.user);
	const translations = useSelector(state => state.translation.translations);
	const showOrHideGeneralLeftMenu = useSelector(
		state => state.generalLeftMenu.showOrHideGeneralLeftMenu,
	);
	const [translationService, setTranslationService] = useState(null);
	const unreadMessgesCount = useSelector(
		state => state.signalR.unreadMessgesCount,
	);
	// const availablePages = useSelector(state => state.user.availablePages);
	const [availablePageId, setAvailablePageId] = useState(null);
	// const [currentUserCountry, setCurrentUserCountry] = useState(null);

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	// useEffect(() => {
	//   getCurrentUserCountry();
	//   return () => {
	//     setCurrentUserCountry(null);
	//   };
	// }, []);

	// const getCurrentUserCountry = () => {
	//   const spinnerId = uuid();
	//   dispatch(addPartialViewSpinner(spinnerId))
	//   GuestApiService.getIpLocationData().then(response => {
	//     if (response && response.data && response.data.country) {
	//       setCurrentUserCountry(response.data.country);
	//     }
	//     dispatch(removePartialViewSpinner(spinnerId))
	//   }).catch(error => getFail(error, spinnerId))
	// }

	// const getFail = (error, spinnerId) => {
	//   error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
	//   spinnerId && dispatch(removePartialViewSpinner(spinnerId));
	// }

	const showOrHideLeftMenu = bool => {
		dispatch(showOrHideGeneralDashboardLeftMenu(bool));
	};

	const setMenuClass = (field, secondField = null) => {
		if (
			secondField &&
			field &&
			props.location.pathname.includes(field) &&
			!props.location.pathname.includes(secondField)
		) {
			return "active-side-left-menu-item";
		}
		if (
			typeof field === "string" &&
			props.location.pathname.includes(field) &&
			!secondField
		) {
			return "active-side-left-menu-item";
		}
		if (props.location.pathname.includes(field.uri) && field.uri !== "/") {
			return "active-side-left-menu-item";
		}
		if (field.uri === "/" && field.children && field.children.length) {
			let isExist = field.children.find(item =>
				props.location.pathname.includes(item.uri),
			);
			if (isExist) {
				return "active-side-left-menu-item";
			}
		}
		return "";
	};

	const setSubMenuClass = field => {
		if (typeof field === "string" && props.location.pathname.includes(field)) {
			return "ml-2";
		}
		return "";
	};

	const showGamifyMenu = () => {
		if (!user || (user && !user.isGamifyAvailable)) {
			return false;
		}
		if (
			user.userTypeId === ADMIN_USER_TYPE ||
			(user.defaultUserTypeIds &&
				user.defaultUserTypeIds.includes(ADMIN_USER_TYPE))
		) {
			return true;
		}
	};

	return translationService && user ? (
		<section
			className={`side-menu-container ${
				showOrHideGeneralLeftMenu ? "show-general-left-menu" : ""
			}`}>
			<div
				className={showOrHideGeneralLeftMenu ? "layer" : ""}
				onClick={() => showOrHideLeftMenu(false)}
			/>
			<aside
				className={`side-left instructor-header-zindex w-fix-left-menu-organization side-left-organization`}>
				<div className="side-left-container">
					<div className="side-left-inner-wrapper">
						<ul className="side-left-list-wrapper">
							<li
								className={`side-left-menu-item has-submenu d-inline-flex  border-bottom w-100`}>
								<Link
									to={`/${language}`}
									title={translationService.translate("TR_HOME")}
									className="p-0"
									onClick={() => showOrHideLeftMenu(false)}>
									<MindalaySvg />
								</Link>
							</li>
							<br />
							<ul>
								<li
									title={translationService.translate(
										"TR_FILE_LIBRARY_B_TWO_B",
									)}
									className={`side-left-menu-item d-block has-submenu w-100 p-0
                  ${setMenuClass(`organization-admin/payment-package/history`)}
                  `}>
									<Link
										to={`/${language}/organization-admin/payment-package/history`}
										className={`nav-link d-block`}
										onClick={() => showOrHideLeftMenu(false)}>
										{translationService.translate("TR_FILE_LIBRARY_B_TWO_B")}
									</Link>
								</li>
								<li
									title={translationService.translate("TR_FAILS_PAGE")}
									className={`side-left-menu-item d-block has-submenu w-100 p-0
                  ${setMenuClass(`organization-admin/payment-package/history`)}
                  `}>
									<Link
										to={`/${language}/organization-admin/payment-package/history`}
										className={`nav-link d-block`}
										onClick={() => showOrHideLeftMenu(false)}>
										{translationService.translate("TR_FAILS_PAGE")}
									</Link>
								</li>
								<li
									className={` side-left-menu-item d-block has-submenu w-100 p-0 ${setMenuClass(
										"user_management",
									)} `}>
									<Link
										to="#"
										title={translationService.translate(
											"TR_CONTAINER_TWO_PAGE",
										)}
										className={` nav-link d-block dropdown-toggle dropdown-toggle-organization `}
										onClick={() =>
											setAvailablePageId(
												availablePageId === "user_management"
													? null
													: "user_management",
											)
										}>
										{translationService.translate("TR_CONTAINER_TWO_PAGE")}
									</Link>
									<ul className="organization-dropdown-sub-pages mt-1 ml-4 d-block">
										<li className={`nav-item`}>
											<Collapse in={availablePageId === "user_management"}>
												<div className=" content-block">
													<Link
														to={`/${language}/developer/user-types`}
														title={translationService.translate(
															"TR_USER_TYPES_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"user-types",
														)}`}>
														{translationService.translate("TR_USER_TYPES_PAGE")}
													</Link>
													<Link
														to={`/${language}/developer/permissions`}
														title={translationService.translate(
															"TR_ROLES_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"permissions",
														)}`}>
														{translationService.translate("TR_ROLES_PAGE")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_USERS_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_USERS_PAGE")}
													</Link>
												</div>
											</Collapse>
										</li>
									</ul>
								</li>
								<li
									className={` side-left-menu-item d-block has-submenu w-100 p-0 ${setMenuClass(
										"gamification",
									)} `}>
									<Link
										to="#"
										title={translationService.translate(
											"TR_CONTAINER_FOUR_PAGE",
										)}
										className={` nav-link d-block dropdown-toggle dropdown-toggle-organization `}
										onClick={() =>
											setAvailablePageId(
												availablePageId === "system_options"
													? null
													: "system_options",
											)
										}>
										{translationService.translate("TR_CONTAINER_FOUR_PAGE")}
									</Link>
									<ul className="organization-dropdown-sub-pages mt-1 ml-4 d-block">
										<li className={`nav-item`}>
											<Collapse in={availablePageId === "system_options"}>
												<div className=" content-block">
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate("TR_LANGUAGES")}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_LANGUAGES")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_TRANSLATIONS_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate(
															"TR_TRANSLATIONS_PAGE",
														)}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_LIBRARY_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_LIBRARY_PAGE")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_PAYMENT_PACKAGES_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate(
															"TR_PAYMENT_PACKAGES_PAGE",
														)}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_CONFIG_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_CONFIG_PAGE")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_CURRENCY_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_CURRENCY_PAGE")}
													</Link>
												</div>
											</Collapse>
										</li>
									</ul>
								</li>
								<li
									className={` side-left-menu-item d-block has-submenu w-100 p-0 ${setMenuClass(
										"gamification",
									)} `}>
									<Link
										to="#"
										title={translationService.translate(
											"TR_CONTAINER_ONE_PAGE",
										)}
										className={` nav-link d-block dropdown-toggle dropdown-toggle-organization `}
										onClick={() =>
											setAvailablePageId(
												availablePageId === "content_management"
													? null
													: "content_management",
											)
										}>
										{translationService.translate("TR_CONTAINER_ONE_PAGE")}
									</Link>
									<ul className="organization-dropdown-sub-pages mt-1 ml-4 d-block">
										<li className={`nav-item`}>
											<Collapse in={availablePageId === "content_management"}>
												<div className="content-block">
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_PAGES_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_PAGES_PAGE")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_CONTENT_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_CONTENT_PAGE")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_CATEGORIES",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_CATEGORIES")}
													</Link>
												</div>
											</Collapse>
										</li>
									</ul>
								</li>
								<li
									className={` side-left-menu-item d-block has-submenu w-100 p-0 ${setMenuClass(
										"gamification",
									)} `}>
									<Link
										to="#"
										title={translationService.translate("TR_DOCUMENTS")}
										className={` nav-link d-block dropdown-toggle dropdown-toggle-organization `}
										onClick={() =>
											setAvailablePageId(
												availablePageId === "documents" ? null : "documents",
											)
										}>
										{translationService.translate("TR_DOCUMENTS")}
									</Link>
									<ul className="organization-dropdown-sub-pages mt-1 ml-4 d-block">
										<li className={`nav-item`}>
											<Collapse in={availablePageId === "documents"}>
												<div className="content-block">
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_ORG_DOCS_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate("TR_ORG_DOCS_PAGE")}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_DOC_TEMPLATES_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate(
															"TR_DOC_TEMPLATES_PAGE",
														)}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_DOC_TEMP_INFO_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate(
															"TR_DOC_TEMP_INFO_PAGE",
														)}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_DOC_TEMP_INFO_DATA_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate(
															"TR_DOC_TEMP_INFO_DATA_PAGE",
														)}
													</Link>
													<Link
														to={`/${language}/gamification/dashboard`}
														title={translationService.translate(
															"TR_DOC_CATEGORY_PAGE",
														)}
														className={`nav-link pl-2 left-submenu-item ${setSubMenuClass(
															"/dashboard",
														)}`}>
														{translationService.translate(
															"TR_DOC_CATEGORY_PAGE",
														)}
													</Link>
												</div>
											</Collapse>
										</li>
									</ul>
								</li>
								{/* <li
									title={translationService.translate("TR_PAYMENT_PACKAGE")}
									className={`side-left-menu-item d-block has-submenu w-100 p-0
                   ${setMenuClass(
											`organization-admin/payment-package`,
											`organization-admin/payment-package/history`,
										)}
                    `}>
									<Link
										to={`/${language}/organization-admin/payment-package`}
										className={`nav-link d-block`}
										onClick={() => showOrHideLeftMenu(false)}>
										{translationService.translate("TR_PAYMENT_PACKAGE")}
									</Link>
								</li>
								<li
									title={translationService.translate(
										"TR_PAYMENT_PACKAGE_HISTORY",
									)}
									className={`side-left-menu-item d-block has-submenu w-100 p-0
                  ${setMenuClass(`organization-admin/payment-package/history`)}
                  `}>
									<Link
										to={`/${language}/organization-admin/payment-package/history`}
										className={`nav-link d-block`}
										onClick={() => showOrHideLeftMenu(false)}>
										{translationService.translate("TR_PAYMENT_PACKAGE_HISTORY")}
									</Link>
								</li>
								<li
									className={`
                                side-left-menu-item d-block has-submenu w-100 p-0 ${setMenuClass(
																	"/educational-unit",
																)}`}>
									<Link
										to={`/${language}/educational-unit`}
										className={` nav-link d-block`}>
										Educational unit
									</Link>
								</li>
								<li
									className={`
                                side-left-menu-item d-block has-submenu w-100 p-0 ${setMenuClass(
																	"/division",
																)}`}>
									<Link
										to={`/${language}/division`}
										className={` nav-link d-block`}>
										Division
									</Link>
								</li>
								{user.innerPayment ? (
									<li
										title={translationService.translate("TR_COURSES")}
										className={`side-left-menu-item d-block has-submenu w-100 p-0
                       ${setMenuClass(`organization-admin/courses`)}
                      `}>
										<Link
											to={`/${language}/organization-admin/courses`}
											className={`nav-link d-block`}
											onClick={() => showOrHideLeftMenu(false)}>
											{translationService.translate("TR_COURSES")}
										</Link>
									</li>
								) : null}
								<li
									title={translationService.translate("TR_MESSAGES")}
									className={`side-left-menu-item d-block has-submenu w-100 p-0
                   ${setMenuClass(`organization-admin/messages`)}
                  `}>
									<Link
										to={`/${language}/organization-admin/messages`}
										className={`nav-link d-block`}
										onClick={() => showOrHideLeftMenu(false)}>
										{translationService.translate("TR_MESSAGES")}
										{unreadMessgesCount ? (
											<span className="unread-messages-count-org">
												{unreadMessgesCount}
											</span>
										) : null}
									</Link>
								</li> */}
								{/* {
                currentUserCountry !== "RU" ?
                  <li
                    className={
                      `side-left-menu-item d-block has-submenu w-100 p-0
                  ${props.location.pathname.includes(`${ORGANIZATION_ADMIN_KEY}/${FINANCES_KEY}`) ? "active-side-left-menu-item" : ""}`
                    }>
                    <Link
                      to={`/${language}/${ORGANIZATION_ADMIN_KEY}/${FINANCES_KEY}`}
                      className={`nav-link d-block`}
                    >
                      {translationService.translate("TR_FINANCES")}
                    </Link>
                  </li>
                  : null
              } */}
							</ul>
						</ul>
					</div>
				</div>
			</aside>
		</section>
	) : null;
};

export default withRouter(DeveloperLeftMenu);
